import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer} from 'react-toastify';
import { fetchReadOnlyData } from "../../redux/readOnly";
import Navbar from "./components/Navbar";
import NewVersionModal from "./components/shared/components/NewVersionModal"
import LoadingBackdrop from "./components/shared/components/LoadingBackdrop";
import { fetchSteps } from "../../redux/incidenciaSteps";
import { fetchMarcas } from "../../redux/marcas";
import { fetchModelos } from "../../redux/modelos";
import { fetchTarifas } from "../../redux/tarifas";
import { fetchTipoPiezas } from "../../redux/tipoPiezas";
import { fetchCarroceriasPesadas } from "../../redux/carroceriasPesadas";
import { fetchPlantillasEmail } from "../../redux/plantillasEmail";
import { fetchTransportistas } from "../../redux/transportistas";
import { fetchVariables } from "../../redux/variables";
import useEcho from "../../hooks/useEcho";
import ReportModal from "./components/shared/components/ReportModal";

const MainLayout = ({onLogout}) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const isDevice = new URLSearchParams(location.search).get('focus') === 'true';
    const loading = useSelector(state => state.loading)
    const reload = useSelector(state => state.reload)
    const [openReport, setOpenReport] = useState(false);
    const webSocketChannel = `read-only`;
    const echo = useEcho();

    useEffect(() => {
        const localStorageReadOnly = localStorage.getItem('read_only');
        if(localStorageReadOnly) {
            const data = JSON.parse(localStorage.getItem('read_only')) || {};
            dispatch({type: 'roles/fullfilled', payload: data.roles || []});
            dispatch({type: 'estados_venta/fullfilled', payload: data.estados_venta || []});
            dispatch({type: 'estados_incidencia/fullfilled', payload: data.estados_incidencia || []});
            dispatch({type: 'subestados_incidencia/fullfilled', payload: data.subestados_incidencia || []});
            dispatch({type: 'tipo_incidencias/fullfilled', payload: data.tipo_incidencias || []});
            dispatch({type: 'tipo_facturas/fullfilled', payload: data.tipo_facturas || []});
            dispatch({type: 'tipo_piezas/fullfilled', payload: data.tipo_piezas || []});
            dispatch({type: 'familia_piezas/fullfilled', payload: data.familia_piezas || []});
            dispatch({type: 'tipo_garantias/fullfilled', payload: data.tipo_garantias || []});
            dispatch({type: 'tipo_clientes/fullfilled', payload: data.tipo_clientes || []});
            dispatch({type: 'tipo_clientes_b2b/fullfilled', payload: data.tipo_clientes_b2b || []});
            dispatch({type: 'tipo_devoluciones/fullfilled', payload: data.tipo_devoluciones || []});
            dispatch({type: 'tipo_feedback/fullfilled', payload: data.tipo_feedback || []});
            dispatch({type: 'tipo_bancos/fullfilled', payload: data.tipo_bancos || []});
            dispatch({type: 'marcas/fullfilled', payload: data.marcas || []});
            dispatch({type: 'modelos/fullfilled', payload: data.modelos || []});
            dispatch({type: 'plataformas/fullfilled', payload: data.plataformas || []});
            dispatch({type: 'paises/fullfilled', payload: data.paises || []});
            dispatch({type: 'tarifas/fullfilled', payload: data.tarifas || []});
            dispatch({type: 'descuentos/fullfilled', payload: data.descuentos || []});
            dispatch({type: 'steps/fullfilled', payload: data.steps || []});
            dispatch({type: 'transportistas/fullfilled', payload: data.transportistas || []});
            dispatch({type: 'servicios_envio/fullfilled', payload: data.servicios_envio || []});
            dispatch({type: 'precios_envios_piezas/fullfilled', payload: data.precios_envios_piezas || []});
            dispatch({type: 'recambistas-messages/fullfilled', payload: data.mensajes || []});
            dispatch({type: 'tarifas_envio_proveedor/fullfilled', payload: data.tarifas_envio_proveedor || []});
            dispatch({type: 'tipo_vencimiento/fullfilled', payload: data.tipo_vencimiento || []});
            dispatch({type: 'recambistas/fullfilled', payload: data.recambistas || []});
            dispatch({type: 'comerciales/fullfilled', payload: data.comerciales || []});
            dispatch({type: 'atencion_cliente/fullfilled', payload: data.atencion_cliente || []});
            dispatch({type: 'administracion/fullfilled', payload: data.finanzas || []});
            dispatch({type: 'carrocerias_pesadas/fullfilled', payload: data.carrocerias_pesadas || []});
            dispatch({type: 'plantillas_email/fullfilled', payload: data.plantillas_email || []});
            dispatch({type: 'solicitud_alternativas/fullfilled', payload: data.solicitud_alternativas || []});
        } else {
            dispatch(fetchReadOnlyData());
        }
    }, []);

    useEffect(() => {
        if (echo) {
            connectWebSocket();
        }

        return () => {
            if (echo) {
              echo.leaveChannel(webSocketChannel);
            }
        }
    }, [echo]);

    const connectWebSocket = () => {
        echo.private(webSocketChannel)
        .listen('.UpdateReadOnly', async (e) => {
            if(e.readOnly === 'incidencia-step') {
                dispatch(fetchSteps());
            } else if(e.readOnly === 'marcas') {
                dispatch(fetchMarcas());
            } else if(e.readOnly === 'modelos') {
                dispatch(fetchModelos());
            } else if(e.readOnly === 'tarifas') {
                dispatch(fetchTarifas());
            } else if(e.readOnly === 'tipo-piezas' || e.readOnly === 'avisos-tipo-piezas') {
                dispatch(fetchTipoPiezas());
            } else if(e.readOnly === 'carrocerias-pesadas') {
                dispatch(fetchCarroceriasPesadas());
            } else if(e.readOnly === 'plantillas-email') {
                dispatch(fetchPlantillasEmail());
            } else if(e.readOnly === 'transportistas') {
                dispatch(fetchTransportistas());
            } else if(e.readOnly === 'variables') {
                dispatch(fetchVariables());
            }
        });
    }

    const handleOpenReportProblem = () => { setOpenReport(true); }
    const handleCloseReportProblem = () => { setOpenReport(false); }

    return (
        <div className="dashboard-container">
            {!isDevice && (
                <Navbar 
                    onOpenReportProblem={handleOpenReportProblem}
                    onLogout={onLogout} />
            )}
            
            <Outlet />

            { loading && <LoadingBackdrop /> }
            { reload && <NewVersionModal /> }

            { (openReport) &&
                <ReportModal 
                    state={openReport}
                    onClose={handleCloseReportProblem}
                />
            }

            <ToastContainer
                containerId="dashboard"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
            />
        </div> 
    );
}

export default MainLayout